import { render, staticRenderFns } from "./ElementDescTableColumn.vue?vue&type=template&id=be8297ea&scoped=true"
import script from "./ElementDescTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementDescTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementDescTableColumn.vue?vue&type=style&index=0&id=be8297ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8297ea",
  null
  
)

export default component.exports